import type { User } from '@core/account-types';
import { EmailSenderKindEnum } from '@core/automated-actions-types';
import type { MailboxInboxPersonal, MailboxInboxShared } from '@core/mailbox-types';
import type { Select2Item } from '@core/user-interface-legacy';

export enum MailboxSelectType {
  All = 'all',
  Personal = 'personal',
  Shared = 'shared_email_provider',
  Deleted = 'deleted',
  AutomatedActionAdmin = EmailSenderKindEnum.Admin,
  AutomatedActionUserPerforming = EmailSenderKindEnum.UserPerformingAction,
  AutomatedActionRecruiter = EmailSenderKindEnum.Recruiter,
  AutomatedActionHiringManager = EmailSenderKindEnum.HiringManager,
}

export const MailboxSelectMyProvider = <const>{ type: MailboxSelectType.All };
export type MailboxSelectPersonalProvider = {
  type: MailboxSelectType.Personal;
  id: number;
  provider: MailboxInboxPersonal;
};

export type MailboxSelectSharedProvider = {
  type: MailboxSelectType.Shared;
  id: number;
  provider?: MailboxInboxShared;
};

export type MailboxSelectAdmin = {
  type: MailboxSelectType.AutomatedActionAdmin;
  id: number;
  user?: User;
};

export const MailboxSelectDeletedEntity = <const>{
  type: MailboxSelectType.Deleted,
};

export const MailboxSelectUserPerformingAction = <const>{
  type: MailboxSelectType.AutomatedActionUserPerforming,
};

export const MailboxSelectRecruiter = <const>{
  type: MailboxSelectType.AutomatedActionRecruiter,
};

export const MailboxSelectHiringManager = <const>{
  type: MailboxSelectType.AutomatedActionHiringManager,
};

export type MailboxInboxSelectValue =
  | MailboxSelectPersonalProvider
  | MailboxSelectSharedProvider
  | typeof MailboxSelectMyProvider;

export type MailboxInboxSelectItem = Select2Item<MailboxInboxSelectValue>;

export type MailboxAASenderSelectValue =
  | MailboxSelectSharedProvider
  | MailboxSelectAdmin
  | typeof MailboxSelectUserPerformingAction
  | typeof MailboxSelectRecruiter
  | typeof MailboxSelectHiringManager
  | typeof MailboxSelectDeletedEntity;

export type MailboxAASenderSelectItem = Select2Item<MailboxAASenderSelectValue>;
export type MailboxSelectItem = MailboxInboxSelectItem | MailboxAASenderSelectItem;
